import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { storage } from './firebase'

export async function uploadImage(file, folder = 'images') {
  try {
    // Generar nombre único para la imagen
    const timestamp = Date.now()
    const filename = `${timestamp}_${file.name}`
    const storageRef = ref(storage, `${folder}/${filename}`)

    // Subir archivo
    await uploadBytes(storageRef, file)

    // Obtener URL descargable
    const downloadURL = await getDownloadURL(storageRef)
    return downloadURL
  } catch (error) {
    console.error('Error uploading image:', error)
    throw error
  }
}

export async function deleteImage() {
  try {
    // Nota: Para eliminar imágenes, se necesitaría implementar esto
    // usando deleteObject(ref(storage, imageUrl))
    // Por ahora solo log de intención
    console.log('Image deletion not implemented yet')
  } catch (error) {
    console.error('Error deleting image:', error)
    throw error
  }
}

